import { BundleBuilderStoreMixinComponent } from '@theme/bundle-builder-mixin-store';

/** @typedef {import('./bundle-builder-store.js').BundleBuilderState} BundleBuilderState */
/** @typedef {import('./bundle-builder-tier-config.js').PurchaseType} PurchaseType */

export class BundleBuilderSummaryItemsComponent extends BundleBuilderStoreMixinComponent {
  requiredRefs = [
    'summaryItemsRegion',
    'summaryItemsList',
    'summaryItemsEmpty',
    'summaryItemTemplate',
  ];

  onStateUpdate() {
    this.#renderSummaryItems();
  }

  #renderSummaryItems() {
    const list = /** @type {HTMLElement} */ (this.refs.summaryItemsList);
    const empty = /** @type {HTMLElement} */ (this.refs.summaryItemsEmpty);
    const template = /** @type {HTMLTemplateElement} */ (this.refs.summaryItemTemplate);
    const itemsRegion = /** @type {HTMLElement} */ (this.refs.summaryItemsRegion);

    if (this.state.items.length === 0) {
      list.replaceChildren();
      empty.hidden = false;
      itemsRegion.classList.remove('bundle-builder__summary-items--active');
      return;
    }

    empty.hidden = true;
    itemsRegion.classList.add('bundle-builder__summary-items--active');

    const desiredProductIds = new Set(
      this.state.items.map((item) => String(item.productId))
    );

    for (const child of [...list.children]) {
      if (!(child instanceof HTMLElement)) continue;
      const productId = child.getAttribute('data-product-id');
      if (productId && !desiredProductIds.has(productId)) {
        child.remove();
      }
    }

    for (let index = 0; index < this.state.items.length; index++) {
      const item = this.state.items[index];
      const productId = String(item.productId);
      let host = list.querySelector(
        `bundle-builder-summary-item-component[data-product-id="${productId}"]`
      );

      if (!host) {
        host = this.#createSummaryItemHost(item, template);
      }

      const referenceNode = list.children[index];
      if (referenceNode !== host) {
        list.insertBefore(host, referenceNode ?? null);
      }
    }
  }

  /**
   * @param {import('./bundle-builder-store.js').BundleItem} item
   * @param {HTMLTemplateElement} template
   * @returns {HTMLElement}
   */
  #createSummaryItemHost(item, template) {
    const host = document.createElement('bundle-builder-summary-item-component');
    host.className = 'bundle-builder__summary-item';
    host.setAttribute('data-product-id', String(item.productId));
    host.setAttribute('role', 'listitem');

    const fragment = /** @type {DocumentFragment} */ (template.content.cloneNode(true));
    const quantitySelector = fragment.querySelector('bundle-builder-quantity-selector-component');
    quantitySelector?.setAttribute('data-product-id', String(item.productId));
    host.append(fragment);
    return host;
  }
}

if (!customElements.get('bundle-builder-summary-items-component')) {
  customElements.define('bundle-builder-summary-items-component', BundleBuilderSummaryItemsComponent);
}
